import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { IoCloseOutline } from 'react-icons/io5';
import { NmCard } from '../NmCard';
import { chartToolbarButtonStyle } from './chartToolbarButtonStyle';
import './ChartCard.css';

interface ChartCardProps {
  title: string;
  subtitle?: string;
  guide: ReactNode;
  onRemove?: () => void;
  className?: string;
  children: ReactNode;
}

/** Shared frame and header for performance charts. */
export function ChartCard({ title, subtitle, guide, onRemove, className = '', children }: ChartCardProps) {
  const { t } = useTranslation();
  return <NmCard className={`chart-card ${className}`}>
    <header className="chart-card__header">
      <div className="chart-card__heading">
        <h3>{title}</h3>
        {subtitle && <p>{subtitle}</p>}
      </div>
      <div className="chart-card__actions">
        {guide}
        {onRemove && <button type="button" style={chartToolbarButtonStyle}
          onClick={onRemove} aria-label={t('charts.workspace.removeWidget')}
          title={t('charts.workspace.removeWidget')}><IoCloseOutline aria-hidden="true" /></button>}
      </div>
    </header>
    {children}
  </NmCard>;
}
